import React from "react";
import { useNavigate } from "react-router-dom";

export default function ContactScreen() {

  const styles = {
    page: {
      minHeight: "100vh",
      background: "#FAFAFA",
      fontFamily: "Inter, sans-serif",
      color: "#0A0A0A",
    },
    hero: {
      maxWidth: 1440,
      margin: "0 auto",
      padding: "120px 64px 90px",
    },
    topRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: 80,
      flexWrap: "wrap",
    },
    brandBlock: {
      maxWidth: 700,
    },
    brandTitle: {
      fontSize: 84,
      fontWeight: 700,
      letterSpacing: "-5px",
      lineHeight: 0.92,
      marginBottom: 34,
      color: "#0A0A0A",
    },
    heroText: {
      fontSize: 34,
      lineHeight: "50px",
      letterSpacing: "-1.4px",
      color: "#6E6E73",
      fontWeight: 400,
      maxWidth: 700,
    },
    rightBlock: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      gap: 18,
      paddingTop: 8,
    },
    contactItem: {
      fontSize: 12,
      fontWeight: 700,
      letterSpacing: "1.8px",
      color: "#111111",
      textTransform: "uppercase",
      textDecoration: "none",
    },
    sectionDivider: {
      width: "100%",
      height: 1,
      background: "rgba(0,0,0,0.06)",
      margin: "90px 0 70px",
    },
    infoGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
      gap: 50,
    },
    infoCard: {
      display: "flex",
      flexDirection: "column",
      gap: 18,
    },
    cardLabel: {
      fontSize: 12,
      fontWeight: 600,
      letterSpacing: "1.2px",
      color: "#A1A1AA",
      textTransform: "uppercase",
    },
    cardText: {
      fontSize: 18,
      lineHeight: "34px",
      color: "#1D1D1F",
      letterSpacing: "-0.3px",
      fontWeight: 500,
    },
    formSection: {
      marginTop: 120,
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 90,
      alignItems: "flex-start",
    },
    formIntro: {
      maxWidth: 520,
    },
    formTitle: {
      fontSize: 52,
      fontWeight: 700,
      letterSpacing: "-3px",
      lineHeight: 1,
      marginBottom: 24,
      color: "#0A0A0A",
    },
    formText: {
      fontSize: 22,
      lineHeight: "38px",
      color: "#6E6E73",
      letterSpacing: "-0.5px",
      fontWeight: 400,
    },
    form: {
      display: "flex",
      flexDirection: "column",
      gap: 22,
      width: "100%",
    },
    input: {
      width: "100%",
      height: 62,
      borderRadius: 18,
      border: "1px solid rgba(0,0,0,0.08)",
      background: "#FFFFFF",
      padding: "0 22px",
      fontSize: 16,
      outline: "none",
      color: "#111111",
      fontWeight: 500,
      letterSpacing: "-0.2px",
      boxSizing: "border-box",
    },
    textarea: {
      width: "100%",
      minHeight: 180,
      borderRadius: 22,
      border: "1px solid rgba(0,0,0,0.08)",
      background: "#FFFFFF",
      padding: "22px",
      fontSize: 16,
      outline: "none",
      resize: "none",
      color: "#111111",
      fontWeight: 500,
      lineHeight: "30px",
      letterSpacing: "-0.2px",
      boxSizing: "border-box",
    },
    button: {
      marginTop: 10,
      height: 62,
      borderRadius: 18,
      border: "none",
      background: "#111111",
      color: "#FFFFFF",
      fontSize: 16,
      fontWeight: 600,
      letterSpacing: "-0.2px",
      cursor: "pointer",
      transition: "all .2s ease",
    },
    successMsg: {
      padding: "16px 20px",
      background: "#EDFDF4",
      border: "1px solid #BBF7D0",
      borderRadius: 14,
      color: "#15803D",
      fontSize: 15,
      fontWeight: 600,
      textAlign: "center"
    },
    footer: {
      marginTop: 120,
      paddingTop: 28,
      borderTop: "1px solid rgba(0,0,0,0.05)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 20,
    },
    footerLeft: {
      fontSize: 12,
      color: "#A1A1AA",
      fontWeight: 500,
      letterSpacing: "-0.1px",
    },
    footerLinks: {
      display: "flex",
      gap: 24,
      flexWrap: "wrap",
    },
    footerLink: {
      fontSize: 12,
      color: "#A1A1AA",
      fontWeight: 500,
      letterSpacing: "-0.1px",
      cursor: "pointer",
      textDecoration: "none",
    },
  };

  const [submitted, setSubmitted] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    setSubmitting(true);
    try {
      const res = await fetch("https://eleven11-i6v4.onrender.com/api/messages", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
  name: form.name.value,
  email: form.email.value,
  phone: form.phone.value,
  company: form.company.value,
  message: form.message.value
})


      });
      if (res.ok) {
        setSubmitted(true);
        form.reset();
      }
    } catch (err) {
      alert("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.hero}>

        {/* HERO */}
        <div style={styles.topRow}>
          <div style={styles.brandBlock}>
            <div style={styles.brandTitle}>Contact</div>
            <div style={styles.heroText}>
              Speak with ELEVEN regarding
              OEM watercraft parts, products,
              dealer accounts, logistics, or
              wholesale distribution.
            </div>
          </div>
          <div style={styles.rightBlock}>
            <a href="mailto:elevensalesinfo@gmail.com" style={styles.contactItem}>
             elevensalesinfo@gmail.com
            </a>
            <div style={styles.contactItem}>(305) 783-6077</div>
          </div>
        </div>

        <div style={styles.sectionDivider}></div>

        {/* INFO */}
        <div style={styles.infoGrid}>
          <div style={styles.infoCard}>
            <div style={styles.cardLabel}>Customer Support</div>
            <div style={styles.cardText}>
              OEM Parts Orders<br />
              Shipping Support<br />
              Returns & Warranty<br />
              General Assistance
            </div>
          </div>
          <div style={styles.infoCard}>
            <div style={styles.cardLabel}>Dealer & Wholesale</div>
            <div style={styles.cardText}>
              Dealer Accounts<br />
              Bulk Inventory Orders<br />
              Distribution Partnerships
            </div>
          </div>
          <div style={styles.infoCard}>
            <div style={styles.cardLabel}>Business Hours</div>
            <div style={styles.cardText}>
              Monday – Friday<br />
              9:00 AM – 6:00 PM EST
            </div>
          </div>
        </div>

        {/* FORM */}
        <div style={styles.formSection}>
          <div style={styles.formIntro}>
            <div style={styles.formTitle}>Let's talk.</div>
            <div style={styles.formText}>
              Our team responds to most
              inquiries within one business day.
            </div>
          </div>

          <form style={styles.form} onSubmit={handleSubmit}>

            {submitted && (
              <div style={styles.successMsg}>
                ✓ Message sent! We'll get back to you within one business day.
              </div>
            )}

          <input name="name" type="text" placeholder="Name" style={styles.input} required />
<input name="email" type="email" placeholder="Email" style={styles.input} required />
<input name="phone" type="tel" placeholder="Phone Number" style={styles.input} required />
<input name="company" type="text" placeholder="Company (Optional)" style={styles.input} />
<textarea name="message" placeholder="Message" style={styles.textarea} required />

            <button type="submit" style={{ ...styles.button, opacity: submitting ? 0.6 : 1 }} disabled={submitting}>
              {submitting ? "Sending..." : "Send Message"}
            </button>

          </form>
        </div>

        {/* FOOTER */}
        <div style={styles.footer}>
          <div style={styles.footerLeft}>© 2026 ELEVEN Industries</div>
        <div style={styles.footerLinks}>
  <a onClick={() => navigate("/privacy")} style={styles.footerLink}>Privacy</a>
  <a onClick={() => navigate("/terms")} style={styles.footerLink}>Terms</a>
  <a onClick={() => navigate("/contact")} style={styles.footerLink}>Dealer Program</a>
</div>
        </div>

      </div>
    </div>
  );
}